import styles from "./vehicle-grid.module.css";
import VehicleFilter from "../Filter";
import VehicleCard from "./components/VehicleCard";
import { TableLoader } from "../../../../components/LoaderC";
import { TablePagination } from "@mui/material";
import { useState } from "react";
import MobileViewList from "../listview/component/MobileViewList";

const isWithin30Days = (createdAt) => {
    if (!createdAt) return false;
    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffInDays = (today - createdDate) / (1000 * 60 * 60 * 24);
    return diffInDays <= 30;
}

const formatPhone = (phone) => {
    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.length !== 10) return phone;

    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}

const VehicleGridView = ({ contentLoading, allData, isGridView, handleView, filterData, setFilterData, setAddModalOpen, setDeleteVehicleModalOpen, setSelectedId, setEditData, setEditModalOpen }) => {
    const [perPage, setPerPage] = useState(8);
    const [page, setPage] = useState(0);

    const tenantVehicles = allData.filter(v => v.is_guest === 0);
    const guestVehicles = allData.filter(v => v.is_guest === 1);

    const rowsData = tenantVehicles.map((tenant) => {
        // Find all tenant vehicles for same lease
        const sameTenantVehicles = tenantVehicles.filter(
            t => t.tenant_id === tenant.tenant_id
        );

        // Primary applicant = lowest tenant_info_id
        const primaryApplicant = sameTenantVehicles.reduce((prev, curr) =>
            curr.tenant_info_id < prev.tenant_info_id ? curr : prev
        );

        const guest =
            primaryApplicant.id === tenant.id
                ? guestVehicles.find(g => g.tenant_id === tenant.tenant_id)
                : null;

        return {
            id: tenant.id,
            initials: tenant.tenant_initial,
            name: tenant.tenant_name,
            license: tenant.license,
            make: tenant.make,
            model: tenant.model,
            color: tenant.color,
            property_id: tenant.property_id,
            property: tenant.property_name,
            unit: tenant.apt_no,
            tenant_image: tenant.tenant_image,
            tenant_id: tenant.tenant_id,
            tenant_info_id: tenant.tenant_info_id,
            apt_id: tenant.apt_id,
            isNew: isWithin30Days(tenant.created_at),
            image_path: tenant.image_path,
            image_thumbail_path: tenant.image_thumbail_path,

            guest: guest ? {
                name: `${guest.guest_fname} ${guest.guest_lname}`,
                phone: formatPhone(guest.guest_phone),
                license: guest.license,
                make: guest.make,
                model: guest.model,
                color: guest.color,
                image_path: guest.image_path,
                image_thumbail_path: guest.image_thumbail_path,
                tenant_id: guest.tenant_id,
                tenant_info_id: guest.tenant_info_id,
                apt_id: guest.apt_id,
                property_id: guest.property_id,
                guest_fname: guest.guest_fname,
                guest_lname: guest.guest_lname,
                guest_phone: guest.guest_phone,
                id: guest.id,
                is_guest: 1
            } : null,
        };
    });

    return <div className={`${styles.BodyCon}`}>
        <div className={`${styles.mainCardDiv}`}>
            <div className={`${styles.mainCard}`}>

                <div className="control-pane">
                    {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                    {!contentLoading && (<div className={`${styles.Row}`}>

                        <VehicleFilter isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} setPage={setPage.bind(this)} setAddModalOpen={setAddModalOpen.bind(this)} />

                        <MobileViewList rowsData={rowsData} setSelectedId={setSelectedId.bind(this)} setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)} setEditData={setEditData.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} />

                        <div className={`${styles.NotesRow}`}>

                            {rowsData?.map((item, index) => {
                                const showBadge = isWithin30Days(item.created_at);
                                return (perPage === -1 || (index >= page * perPage && index < page * perPage + perPage)) ? <VehicleCard item={item} showBadge={showBadge} setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)} setSelectedId={setSelectedId.bind(this)} setEditData={setEditData.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} /> : null;
                            })}

                            {rowsData.length > 0 && (<div className="Pagination TablePaginationNew List">
                                <TablePagination
                                    count={rowsData.length}
                                    color="primary"
                                    page={page}
                                    rowsPerPage={perPage}
                                    onPageChange={(e, v) => setPage(v)}
                                    rowsPerPageOptions={[
                                        { label: '4', value: 4 },
                                        { label: '8', value: 8 },
                                        { label: '16', value: 16 },
                                        { label: 'All', value: -1 },
                                    ]}
                                    onRowsPerPageChange={(e) => {
                                        setPage(0);
                                        setPerPage(e.target.value);
                                    }}
                                    labelRowsPerPage={'Vehicles per Page:'}
                                />
                            </div>)}

                            {rowsData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                <div className={`${styles.NoDataIMG}`}>
                                    <img src="/static/img/no-car.png" alt="No Data" />
                                </div>
                                <p className={`${styles.NoDataText}`}>Unfortunately!</p>
                                <p className={`${styles.NoDataTextSub}`}>we couldn't find any vehicle at this time.</p>
                            </div>)}

                        </div>
                    </div>)}

                </div>
            </div>
        </div>
    </div>
}

export default VehicleGridView;